<template>
  <div>
    <CRow>
      <CCol col="12" xl="12">
        <CCard>
          <PageTitle title="Transaction View Log" :rows="rows" />
          <CCardBody>
            <SubNav :csv_export="csv_export" />
            <div class="overflow-auto">
              <b-table
                id="my-table"
                :items="items"
                :fields="fields"
                :per-page="perPage"
                :current-page="currentPage"
                primary-key="logid"
                small
              >
                <template #cell(detailLink)="data">
                  <a
                    :href="data.item.detailLink"
                    style="text-decoration: underline"
                    target="new"
                    >{{ data.item.detailLink.substring(0, 50)+"..." }}</a
                  >
                </template>
                <template #cell(count)="data">
                  {{ data.item.count }} <br />
                  <a
                    href="javascript:void(0)"
                    @click="() => view_details(data.item.viewLogs)"
                    style="text-decoration: underline"
                    >click for more info</a
                  >
                </template>
              </b-table>
              <b-pagination
                v-model="currentPage"
                :total-rows="rows"
                :per-page="perPage"
                aria-controls="my-table"
                style="float: right"
              ></b-pagination>
            </div>
          </CCardBody>
        </CCard>
      </CCol>
      <CCol>
        <CModal
          :show.sync="modalShow"
          :no-close-on-backdrop="true"
          :centered="true"
          title="Detailed Log"
          color="dark"
          size="lg"
        >
          <div class="overflow-auto">
            <b-table
              id="detailTable"
              :items="item_details"
              :fields="item_details_fields"
              :per-page="item_details_perPage"
              :current-page="item_details_currentPage"
              primary-key="index"
              small
            >
              <template #cell(index)="data">
                {{ data.index + 1 }}
              </template>
              <template #cell(country)="data">
                {{ regionNames.of(data.item.country) }}
              </template>
            </b-table>
          </div>
          <template #header>
            <h6 class="modal-title">Detailed Log</h6>
            <CButtonClose @click="modalShow = false" class="text-white" />
          </template>
          <template #footer>
            <div></div>
          </template>
        </CModal>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import firebase from "firebase";

import {
  timeConverter,
  from_0,
  to_24,
  getDateLabel,
} from "../../common-functions.js";
import * as Const from "../../const.js";

import PageTitle from "../component/PageTitle.vue";
import SubNav from "../component/SubNav.vue";

export default {
  name: "TransactionViewLog",
  components: { PageTitle, SubNav },
  data() {
    return {
      modalShow: false,
      currentPage: 1,
      perPage: Const.perPage,
      items: [],
      fields: [
        { key: "uname", label: "User Name", sortable: true },

        { key: "bname", label: "Business Name", sortable: true },

        { key: "cname", label: "Customer Name", sortable: true },
        {
          key: "cphoneNumber",
          label: "Customer Phone",
          sortable: true,
        },

        {
          key: "totalBalance",
          label: "Total Balance",
          _classes: "font-weight-bold",
          sortable: true,
        },
        {
          key: "detailLink",
          label: "Link",
          _classes: "font-weight-bold",
          sortable: true,
        },
        { key: "count", label: "Count", sortable: true },
        { key: "updatedAt", label: "updated At", sortable: true },
        { key: "createdAt", label: "Created At", sortable: true },
      ],
      activePage: 1,

      item_details: [],
      item_details_fields: [
        { key: "index", label: "No", sortable: false },
        { key: "ip", label: "IP", sortable: true },
        { key: "city", label: "City", sortable: true },
        { key: "country", label: "Country", sortable: true },
        { key: "meta_ua", label: "Agent", sortable: false },
      ],
      item_details_perPage: 10,
      item_details_currentPage: 0,

      regionNames: Const.regionNames,
    };
  },

  computed: {
    rows() {
      return this.items.length;
    },
    need_refresh() {
      return (
        this.$store.state.selcountryCode +
        (this.$store.state.showSubNav.user
          ? "-" + this.$store.state.seluid
          : "") +
        (this.$store.state.showSubNav.business
          ? "-" + this.$store.state.selbid
          : "") +
        (this.$store.state.showSubNav.customer
          ? "-" + this.$store.state.selcid
          : "") +
        (this.$store.state.showSubNav.date
          ? "-" + getDateLabel(this.$store.state.from, this.$store.state.to)
          : "")
      );
    },
  },
  watch: {
    $route: {
      immediate: true,
      handler(route) {
        if (route.query && route.query.page) {
          this.activePage = Number(route.query.page);
        }
      },
    },
  },
  watch: {
    need_refresh: {
      immediate: true,
      handler(value) {
        this.load("data");
      },
    },
  },
  created() {
    this.$store.commit("set", [
      "showSubNav",
      { user: true, business: true, customer: true, date: false },
    ]);
  },

  methods: {
    load(type) {
      const db = firebase.firestore();

      if (type == "data") {
        var ref = db.collection("transaction_detail_view_log");
        //if (this.seluid == "") return;
        this.$store.commit("set", ["loading_data", true]);

        if (this.$store.state.seluid != "")
          ref = ref.where("uid", "==", this.$store.state.seluid);
        if (this.$store.state.selbid != "")
          ref = ref.where("bid", "==", this.$store.state.selbid);
        if (this.$store.state.selcid != "")
          ref = ref.where("cid", "==", this.$store.state.selcid);
        if (this.$store.state.selcountryCode != "")
          ref = ref.where(
            "countryNameCode",
            "==",
            this.$store.state.selcountryCode
          );

        try {
          ref
            .orderBy("updatedAt", "desc")
            //.limit(1)
            .get()
            .then((querySnapshot) => {
              this.items = [];
              this.page = 0;
              //this.data = [];
              querySnapshot.forEach((doc) => {
                var entry = {
                  logid: doc.id,
                  uname: doc.data().uname,
                  uid: doc.data().uid,
                  bname: doc.data().bname,
                  bid: doc.data().bid,
                  cid: doc.data().cid,
                  cname: doc.data().cname,
                  cphoneNumber: doc.data().cphoneNumber,

                  totalBalance: doc.data().totalBalance,
                  detailLink: doc.data().detailLink,
                  updatedAt: timeConverter(doc.data().updatedAt.seconds),
                  createdAt: timeConverter(doc.data().createdAt.seconds),
                  count: doc.data().viewLogs?.length || 0,
                  viewLogs: doc.data().viewLogs,
                };
                this.items.push(entry);
                //this.setNames(db, entry);
              });

              this.$store.commit("set", ["loading_data", false]);
            });
        } catch (e) {
          console.log(e);
          this.$store.commit("set", ["loading_data", false]);
        } finally {
        }
      }
    },
    rowClicked(item, index) {
      // this.$router.push({ path: `businesses/${this.items[index].uid}` });
    },
    pageChange(val) {
      this.$router.push({ query: { page: val } });
    },

    csv_export() {
      let csvContent = "";
      var header = [
        "User Name",
        "User ID",
        "Business Name",
        "Business ID",
        "Customer Name",
        "Customer ID",
        "Customer Phone",
        "Total Balance",
        "Detail Link",
        "View Count",
        "UpdatedAt",
        "CreatedAt",
      ];
      var universalBOM = "\uFEFF";
      let row = header.join(",");
      csvContent += row + "\r\n";

      this.items.forEach(function (row) {
        var row_str = "";
        row_str += '"' + row.uname + '",';
        row_str += '"' + row.uid + ' ",';
        row_str += '"' + row.bname + '",';
        row_str += '"' + row.bid + '",';
        row_str += '"' + row.cname + '",';
        row_str += '"' + row.cid + '",';
        row_str += '"' + row.cphoneNumber + '",';
        row_str += '"' + row.totalBalance + '",';
        row_str += '"' + row.detailLink + '",';
        row_str += '"' + row.count + '",';
        row_str += '"' + row.updatedAt + '",';
        row_str += '"' + row.createdAt + '",';

        csvContent += row_str + "\r\n";
      });
      var universalBOM = "\uFEFF";
      var a = window.document.createElement("a");
      a.setAttribute(
        "href",
        "data:text/csv; charset=utf-8," +
          encodeURIComponent(universalBOM + csvContent)
      );
      a.setAttribute("download", "viewlogs_" + this.need_refresh + ".csv");
      window.document.body.appendChild(a);
      a.click();
    },
    view_details(item_details) {
      console.log(item_details);
      this.item_details = item_details;
      this.modalShow = true;
    },
  },
};
</script>
<style>
</style>
